<template>
  <div>

    <v-row  justify-md="center">
      <v-col sm="10" md="7">
        <v-tabs fixed-tabs v-model="tabs" centered>
          <v-tab href="#friendslist"> Friends </v-tab>
          <v-tab href="#requests"> Requests </v-tab>
          <v-tab href="#blocked"> Blocked </v-tab>
        </v-tabs>
        
        <v-tabs-items :value="tabs" background-color="transparent" color="" class="pa-4">
          <v-tab-item value="friendslist" :eager="true" color="red" >
            <v-row  justify-md="end">
              <v-col class="d-flex justify-content-end">
                <v-btn @click="addFriendDialog = true"><v-icon x-small>mdi-plus</v-icon>&nbsp;Add friend</v-btn>
              </v-col>
            </v-row>

            <br>
            <v-alert v-if="friends != null && 
                            friends.approved_friends != null && 
                            friends.approved_friends.length === 0" 
                      type="info" border="left" dense text
                      class="mb-0">
              You don't have any friends yet
            </v-alert>
            
            <div v-else>
              <v-simple-table v-if="friends != null && friends.approved_friends != null">
                <thead>
                  <tr>
                    <th class="text-left">
                      Online
                    </th>
                    <th class="text-left">
                      Display Name
                    </th>
                    <th class="text-left">
                      Muted
                    </th>
                    <th class="text-left">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fr in friends.approved_friends" v-bind:key="fr.friend_account_unique_display_name"> 
                    <td>
                      <v-icon v-show="fr != null && fr.online_status === 1" color="green">mdi-checkbox-blank-circle</v-icon>
                      <v-icon v-show="fr != null && fr.online_status === 0" color="red" x-small>mdi-checkbox-blank-circle</v-icon>
                    </td>
                    <td>
                      {{ fr.friend_account_unique_display_name }}
                    </td>
                    <td>
                      <v-icon v-show="fr != null && fr.muted_at.valid" color="red">mdi-microphone-off</v-icon>
                    </td>
                    <td>
                      <v-menu left bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-show="!fr.muted_at.valid" @click="muteFriend(fr.friend_account_id)">Mute</v-list-item>
                          <v-list-item v-show="fr.muted_at.valid" @click="unmuteFriend(fr.friend_account_id)">Unmute</v-list-item>
                          <v-list-item @click="blockFriend(fr.friend_account_id)"
                            >Block</v-list-item
                          >
                          <v-list-item @click="removeFriend(fr.friend_account_id)"
                            >Remove</v-list-item
                          >
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-tab-item>

          <v-tab-item value="requests" :eager="true">
            <v-alert v-if="friends != null && 
                            friends.received_friend_requests != null && 
                            friends.sent_friend_requests != null &&
                            friends.received_friend_requests.length == 0 &&
                            friends.sent_friend_requests.length == 0" 
                      type="info" border="left" dense text
                      class="mb-0">
              You don't have any pending requests
            </v-alert>

            <div v-else>
              <v-expansion-panels v-if="friends != null" multiple focusable v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div v-if="friends.received_friend_requests != null">
                      Friend requests received&nbsp;<small>({{ friends.received_friend_requests.length }})</small>
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-simple-table v-if="friends.received_friend_requests != null" class="mt-4">             
                      <tbody>
                        <tr v-for="fr in friends.received_friend_requests"
                            v-bind:key="fr.friend_account_unique_display_name">

                          <td>{{ fr.friend_account_unique_display_name }}</td>

                          <td align="right">
                            <v-btn @click="approveFriendRequest(fr.friend_account_id)" icon>
                              <v-icon hint="Approve friend">mdi-check</v-icon>
                            </v-btn>
                            <v-btn @click="declineFriendRequest(fr.friend_account_id)" icon>
                              <v-icon hint="Decline friend">mdi-window-close</v-icon>
                            </v-btn>
                          </td>

                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div v-if="friends.sent_friend_requests != null">
                      Friend requests sent&nbsp;<small>({{ friends.sent_friend_requests.length }})</small>
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-simple-table v-if="friends.sent_friend_requests != null" class="mt-4">               
                        <tbody>
                          <tr v-for="fr in friends.sent_friend_requests"
                              v-bind:key="fr.friend_account_unique_display_name">

                            <td>{{ fr.friend_account_unique_display_name }}</td>

                            <td align="right">
                              <v-btn @click="removeFriendRequest(fr.friend_account_id)" icon>
                                <v-icon>mdi-window-close</v-icon>
                              </v-btn>
                            </td>

                          </tr>
                        </tbody>
                      </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-tab-item>

          <v-tab-item value="blocked" :eager="true">
                  <v-alert v-if="friends != null && friends.blocked_friends != null && friends.blocked_friends.length == 0" 
                          type="info" border="left" dense text
                          class="mb-0">
                    You don't have any blocked friends
                  </v-alert>

                  <v-simple-table v-else>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Online
                        </th>
                        <th class="text-left">
                          Display Name
                        </th>
                        <th class="text-left">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="friend in friends.blocked_friends"
                          v-bind:key="friend.friend_account_unique_display_name">
                        <td>
                          <v-icon v-show="friend != null && friend.online_status === 1" color="green" x-small>
                            mdi-checkbox-blank-circle
                          </v-icon>
                          <v-icon v-show="friend != null && friend.online_status === 0" color="red" x-small>
                            mdi-checkbox-blank-circle
                          </v-icon>
                        </td>
                        <td>
                          {{ friend.friend_account_unique_display_name }}
                        </td>
                        <td>
                          <v-menu left bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="removeFriend(friend.friend_account_id)">Remove</v-list-item>
                              <v-list-item @click="unblockFriend(friend.friend_account_id)">Unblock</v-list-item>
                            </v-list>
                          </v-menu>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-dialog
      v-model="addFriendDialog"
      persistent
      max-width="500"
      :fullscreen="$vuetify.breakpoint.mobile">

      <form @submit.prevent="addFriend" name="form">
        <v-card>
          <v-card-title>
            <span class="headline">Add a friend</span>
          </v-card-title>
          <v-card-text>
          <v-snackbar
            v-model="addFriendFailed"
            :color="'error'"
            :timeout="6000"
            :top="true">
            <div>
           {{changeFriendStatusMessage}}
           </div>
          </v-snackbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Display Name*"
                  v-model="friendDisplayName"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" @click.native="closeAddFriendDialog()"
              >Cancel</v-btn
            >
            <v-btn type="submit" :disabled="$v.friendDisplayName.$invalid"
              >Send</v-btn
            >
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
  </div>
</template>
<style scoped>

</style>
<script>
import { createNamespacedHelpers } from "vuex";
import store from "../store";
import { required } from "vuelidate/lib/validators";

import { account } from "../store/modules/account";

if (!store.state.account) store.registerModule("account", account);
const { mapState } = createNamespacedHelpers("account");
 
export default {
  name: "Friends",  
  data() {
    return {
      addFriendDialog: false,
      friendDisplayName: "",
      addFriendFailed: false,
      changeFriendStatusMessage:"",
      panel: [],
    };
  },
  validations() {
    return {
      friendDisplayName: {
        required,
       // pattern: /\w{3,}\s#\d+/,
        //message: "Friend name must me in format DisplayName #1234"
      },
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapState(["friends", "medata"]),
    tabs: {
      set(tabs) {
        this.$router.replace({ query: { ...this.$route.query, tabs } });
      },
      get() {
        return this.$route.query.tabs;
      },
    },
  },
  methods: {
    fetchData() {
      this.$store.dispatch("account/getAllFriends").then((resp) => {
        if (resp.received_friend_requests.length && resp.sent_friend_requests.length) {
          this.panel = [0, 1]
        } else {
          this.panel = [resp.received_friend_requests.length ? 0 : (resp.sent_friend_requests.length ? 1 : null)]
        }
      })
    },    
    closeAddFriendDialog() {
      this.friendDisplayName = "";
      this.addFriendDialog = false;
      this.fetchData();
    },
    addFriend() {
      this.$store
        .dispatch("account/addFriend", {
          friendDisplayName: this.friendDisplayName,
        }).then(() => {
          this.closeAddFriendDialog();
        }).catch(() => {
          this.changeFriendStatusMessage = "Friend not found";
          this.addFriendFailed = true;
      });
    },
    removeFriend(friendaccountid){ 
      this.$store
        .dispatch("account/removeFriend", {
          friendAccountID: friendaccountid,
        }).then(() => {
          
           this.fetchData();
        }).catch(() => {
          this.changeFriendStatusMessage = "Cannot remove friend";          
      });
    },
    removeFriendRequest(friendaccountid) {
      this.$store
        .dispatch("account/removeFriendRequest", {          
          friendAccountID: friendaccountid,
        }).then(() => {           
           
           this.fetchData();           
        }).catch(() => {
          this.changeFriendStatusMessage = "Cannot remove friend request";         
      });
    },
    declineFriendRequest(friendaccountid) {
       this.$store
        .dispatch("account/declineFriendRequest", {
          friendAccountID: friendaccountid,
        }).then(() => {
           this.fetchData();
        }).catch(() => {
          this.changeFriendStatusMessage = "Cannot decline friend request";         
      });
    },
    approveFriendRequest(friendaccountid) { 
      this.$store
        .dispatch("account/approveFriendRequest", {
          friendAccountID: friendaccountid,
        }).then(() => {
           this.fetchData();
        }).catch(() => {
          this.changeFriendStatusMessage = "Cannot remove friend request";         
      });
    },
    muteFriend(friendaccountid) { 
      this.$store
        .dispatch("account/muteFriend", {
          friendAccountID: friendaccountid,
        }).then(() => {
           this.fetchData();
        }).catch(() => {
          this.changeFriendStatusMessage = "Cannot mute friend";         
      });
    },
    unmuteFriend(friendaccountid) { 
      this.$store
        .dispatch("account/unmuteFriend", {
          friendAccountID: friendaccountid,
        }).then(() => {
           this.fetchData();
        }).catch(() => {
          this.changeFriendStatusMessage = "Cannot mute friend";         
      });
    },
    blockFriend(friendaccountid) { 
      this.$store
        .dispatch("account/blockFriend", {
          friendAccountID: friendaccountid,
        }).then(() => {
           this.fetchData();
        }).catch(() => {
          this.changeFriendStatusMessage = "Cannot block friend";         
      });
    },
    unblockFriend(friendaccountid) { 
      this.$store
        .dispatch("account/unblockFriend", {
          friendAccountID: friendaccountid,
        }).then(() => {
           this.fetchData();
        }).catch(() => {
          this.changeFriendStatusMessage = "Cannot unblock friend";         
      });
    },
  },
};

</script>